import { createSlice } from '@reduxjs/toolkit';
import { fetchLeasingOffersDetails } from './thunks';
import { LeasingOfferDetails } from '../../types/LeasingOffer';

export interface LeasingOffersDetailsState {
  loading: boolean;
  leasingOfferDetails?: LeasingOfferDetails;
  error?: string;
}

const initialState: LeasingOffersDetailsState = {
  loading: false,
  leasingOfferDetails: undefined,
  error: undefined,
};

export const leasingOfferDetailsSlice = createSlice({
  name: 'leasingOfferDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLeasingOffersDetails.pending, (state) => {
      state.loading = true;
      state.leasingOfferDetails = initialState.leasingOfferDetails;
      state.error = initialState.error;
    });
    builder.addCase(fetchLeasingOffersDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.leasingOfferDetails = action.payload;
      state.error = initialState.error;
    });
    builder.addCase(fetchLeasingOffersDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
    });
  },
});

export default leasingOfferDetailsSlice.reducer;
